import * as React from 'react';

import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from '../lib/utils';

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    indicatorClassName?: string;
    indicatorLabel?: string;
    isMasked?: boolean;
  }
>(
  (
    {
      className,
      indicatorClassName,
      indicatorLabel,
      isMasked,
      style,
      value,
      ...props
    },
    ref,
  ) => (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        'vai-relative vai-h-4 vai-w-full vai-overflow-hidden vai-rounded-full vai-bg-background',
        className,
      )}
      style={{
        // These styles force the background colors to appear when printed
        // rather than stripped entirely, which apparently is common behavior
        // for browsers.
        printColorAdjust: 'exact',
        WebkitPrintColorAdjust: 'exact',
        colorAdjust: 'exact',
        ...style,
      }}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className={cn(
          'vai-h-full vai-flex-1 vai-transition-all vai-rounded-tr-lg vai-rounded-br-lg vai-relative',
          indicatorClassName,
          { 'vai-w-full': isMasked },
        )}
        style={
          isMasked
            ? {
                maskImage: `linear-gradient(to right, black ${value}%, transparent ${value}%)`,
                WebkitMaskImage: `linear-gradient(to right, black ${value}%, transparent ${value}%)`,
              }
            : {
                width: `${value}%`,
              }
          // transform: `translateX(-${100 - (value || 0)}%)`,
        }
      >
        {indicatorLabel && (
          <div
            className={cn('vai-absolute vai-flex vai-justify-end vai-pr-1', {
              'vai-left-0': isMasked,
              'vai-right-0': !isMasked,
            })}
            style={isMasked ? { width: `${value}%` } : {}}
          >
            <p className="vai-inter vai-text-xs vai-font-medium vai-text-white">
              {indicatorLabel}
            </p>
          </div>
        )}
      </ProgressPrimitive.Indicator>
    </ProgressPrimitive.Root>
  ),
);
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
